<template>
  <div id="app">
    <el-container>
      <el-header class="div-header">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>

      <div class="main-div" v-loading.fullscreen.lock="fullscreenLoading">
        <el-container class="parentDiv">
          <splitpanes class="default-theme defaultStyle custom-splite">
            <pane size="100" class="SideBarLeft">
              <div class="SID1019-002_SearchRegScreen">
                <!-- Breadcrumb section -->
                <section>
                  <el-breadcrumb separator-class="el-icon-arrow-right" class="SearchRegLink">
                    <el-breadcrumb-item :to="{ path: '0002' }">トップ(記事一覧)</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '1019-001' }">トピックス作成(初期状態) </el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">トピックス作成</el-breadcrumb-item>
                  </el-breadcrumb>
                </section>

                <!-- Info div section -->
                <section class="layoutSectionTop">
                  <el-row>
                    <el-col class="ColumnLayoutTop">
                      <el-button type="primary" class="buttonInformation">
                        <i class="fas fa-user"></i>
                      </el-button>
                    </el-col>
                    <el-col class="ColumnLayoutTop">
                      <span class="spanTopicTitle">
                        {{getTitle}}
                        <el-link :underline="false" type="primary">{{this.$route.params.secondScreen.title}}</el-link>
                      </span>
                    </el-col>
                    <el-col class="ColumnLayoutTop">
                      <span>
                        {{getMedia}}
                        <el-link :underline="false" type="primary">{{this.$route.params.secondScreen.media}}</el-link>
                      </span>
                    </el-col>
                    <el-col class="ColumnLayoutTop">
                      <span class="clipDateSpan">
                        {{getClipText}}
                        <el-link :underline="false" type="primary">{{this.$route.params.secondScreen.date}}</el-link>
                      </span>
                    </el-col>
                    <el-col class="ColumnLayoutTop">
                      <el-button type="danger" @click="AID0047_Add" class="topicRegistration">
                        <i class="fas fa-copy"></i> トピックス登録
                      </el-button>
                    </el-col>
                  </el-row>
                  <el-row class="ButtonFilterTopSection">
                    <el-button type="primary" @click="Goto_SID1019_001" plain>中止</el-button>
                    <el-button type="danger" @click="AID0099_DeleteAll" plain>削除</el-button>
                  </el-row>
                </section>

                <!-- Topic registration information section -->
                <section class="AriticleInformation">
                  <span>[記事選択]からトピックスに表示したい記事を選択してください。</span>
                  <span>[並び替え]でトピックス記事一覧の表示順番を変更できます</span>
                  <span>作成が終わったら「トピックス登録」ボタンを押してください。</span>
                 <!-- Change by SJ for backlog Id: 1560 -->
                  <!-- 2021/02/07 #10041 START-->
                  <!-- <span>{{ getcountMax }}</span>-->
                  <span v-if="this.media_section == 1">{{ getcountMax }}</span>
                  <!-- 2021/02/07 #10041 END-->
                </section>

                <!-- Collapse tab section -->
                <section>
                  <el-tabs v-model="activeName">
                    <el-tab-pane label="記事選択" name="first">
                      <section>
                        <el-form ref="formName" :model="form" :rules="rules" class="firstTabFormSection">
                          <el-row :gutter="10">
                            <el-col :span="4">
                              <div>キーワード</div>
                              <span class="alertSpan">{{alert_keyword}}</span>
                              <el-input v-model="input1" :disabled="clickable" placeholder="キーワード..."></el-input>
                            </el-col>
                            <el-col :span="4" class="secondColumn">
                              <div>媒体名</div>
                              <span class="alertSpan">{{alert_medianame}}</span>
                              <el-input v-model="input2" :disabled="clickable" placeholder="媒体名..."></el-input>
                            </el-col>
                            <el-col :span="4">
                              <div class="themelabel">検索条件</div>
                              <el-select 
                                v-model="value1"
                                placeholder="検索条件から選択"
                                class="firstTabOption"
                                @change="changeConditions"
                              >
                                <el-option
                                  v-for="item in getDropdownForSearchSituation"
                                  :key="item.title"
                                  :label="item.title"
                                  :value="item.title"
                                ></el-option>
                              </el-select>
                            </el-col>
                            <el-col :span="5">
                              <div class="clippinglabel">クリッピング日</div>
                              <div class="FirstTabDatepicker">
                                 
                                <v-date-picker
                                  :masks="{ title: 'YYYY年MMM' }"
                                  v-model="date"
                                  locale="ja"
                                  id="Date1019"
                                  mode="range"
                                  @change="calenderChange"
                                  :input-props = "{readonly: true}"
                                  :popover="{  visibility: 'click' }"
                                />
                              </div>
                            </el-col>
                            <el-col :span="4">
                               <div class="themelabel">テーマ</div>
                              <el-select
                                v-model="theme_name"
                                placeholder="テーマを選択"
                                class="firstTabOption"
                                  @change="theme_condition"
                              >
                                <el-option
                                  v-for="theme in getDropdownFortheme"
                                  :key="theme.theme_id"
                                  :label="theme.theme_name"
                                  :value="theme.theme_id"
                                ></el-option>
                              </el-select>
                            </el-col>
                            <el-col :span="3">
                              <div class="FirstTabSearchButton">
                                <!-- 2022/09/12  #13561  START -->
                                <el-button type="primary" @click="AID0071_Search()" plain :disabled="Buttonpressed == 1">検索</el-button>
                                <!-- 2022/09/12  #13561  END -->
                              </div>
                            </el-col>
                          </el-row>
                        </el-form>
                        <span>
                          {{ startDate }}から{{ endDate }}のデータは
                          <el-link
                            :underline="false"
                            type="primary"
                            class="customfontSizeChange"
                          >{{articlecount}}件</el-link>です
                        </span>
                      </section>
                      <section class="fixedHeadTableSection">
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                        <el-table
                          ref="multipleTable"
                          v-loading="loading"
                          :data="getTableResult1019002"
                          :span-method="arraySpanMethod"
                          @selection-change="handleSelectionChange"
                          border
                          style="width: 100%"
                          :cell-class-name="tableCellClassName"
                        >
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                        <el-table-column type="selection" width="55"></el-table-column>
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                        <el-table-column prop="No" label="No." width="60" type="index">
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                            <template slot-scope="scope">
                                <span class="commentIcon" v-if="scope.row.theme_name == 'Comment'"></span>
                                {{scope.row.no}}
                              </template>
                          </el-table-column>
                          <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                          <!-- 2023/09/22  #14935 START-->
                          <el-table-column prop="title" label="見出し" min-width="460">
                            <!-- 2023/09/22  #14935 END-->
                          <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                           <!--  <template slot-scope="scope" >
                              <el-link
                                type="primary"
                                :underline="true"
                                class="ArticleLink"
                                v-html="scope.row.title"
                              ></el-link> 
                              <span class="linkToNextPage"  @click="openPdfConfirmationDialog(scope.row.article_id,scope.row.data_section,scope.row.url)">{{scope.row.title}}</span>
                            </template>-->
                             <template slot-scope="scope" >                             
                              <div v-if="scope.row.article_id != '' && scope.row.article_id != null">   
                                <div v-if="scope.row.data_section == 1">
                                  <span v-if="mc_pdf_view_flag == false || scope.row.no_image_flag == true" class="ArticleTitleFor1019">{{scope.row.title}}</span>
                                  <el-link
                                    v-else
                                    :underline="false"
                                    type="primary"
                                    v-html="scope.row.title"
                                    @click="openPdfConfirmationDialog(scope.row.article_id,scope.row.data_section,scope.row.url)"
                                    class="UserComment"
                                  ></el-link>
                                  
                                </div>
                                <div v-else-if="scope.row.data_section == 2">
                                  <span v-if="sc_pdf_view_flag == false || scope.row.no_image_flag == true" class="ArticleTitleFor1019">{{scope.row.title}}</span>
                                  <el-link
                                    v-else
                                    :underline="false"
                                    type="primary"
                                    v-html="scope.row.title"
                                    @click="openPdfConfirmationDialog(scope.row.article_id,scope.row.data_section,scope.row.url)"
                                    class="UserComment"
                                  ></el-link>
                                  
                                </div> 
                                <div v-else-if="scope.row.data_section == 3">
                                  <el-link
                                    :underline="false"
                                    type="primary"
                                    v-html="scope.row.title"
                                    @click="openPdfConfirmationDialog(scope.row.article_id,scope.row.data_section,scope.row.url)"
                                    class="UserComment"
                                  ></el-link> 
                                </div>                                                             
                                <div v-else-if="scope.row.data_section == 5">
                                  <el-link v-if="scope.row.sales_datetime_flag == true"
                                    :underline="false"
                                    type="primary"
                                    v-html="scope.row.title"
                                    @click="$gotoEpub(scope.row.contents_id,scope.row.start_page,scope.row.sales_to_datetime)"
                                    class="UserComment"
                                  ></el-link> 
                                  <div v-else-if="scope.row.sales_datetime_flag == false" style="color: black;cursor: auto;font-weight:normal;">
                                    {{ scope.row.title }}
                                  </div>
                                </div>  
                              </div>
                              <div v-else>
                                <el-link
                                  :underline="false"
                                  type="primary"
                                  v-html="scope.row.title"
                                  class="UserComment nonurl"
                                ></el-link>
                              </div>
                            </template>
                          </el-table-column>
                          <!-- 2023/09/22  #14935 START-->
                          <el-table-column min-width="160" label="媒体名">
                          <!-- 2023/09/22  #14935 END-->
                            <template slot-scope="scope" v-if="scope.row.theme_name != 'Comment'">
                              <span style v-if="scope.row.data_section == 1">
                                {{ scope.row.media_name }}
                                <br />
                                <img
                                  class="tableInside-img"
                                  src="../../assets/image/logo-new.png"
                                  alt="LOGO"
                                />
                              </span>
                              <span style v-else-if="scope.row.data_section == 2">
                                {{ scope.row.media_name }}
                                <br />
                                <img
                                  class="tableInside-img"
                                  src="../../assets/image/Nikkie-logo-web.svg"
                                  alt="LOGO"
                                />
                              </span>
                              <span  style v-else-if="scope.row.data_section == 3">
                                {{ scope.row.media_name }}
                                
                                <!-- <img 
                                  class="tableInside-img"
                                  src="../../assets/image/logo-new.png"
                                  alt="LOGO"
                                /> -->
                              </span>
                              <span  style v-else-if="scope.row.data_section == 5">
                                {{ scope.row.media_name }}
                              </span>
                            </template>
                          </el-table-column>
                          <el-table-column prop="issue_date" label="年月日" width="120" v-if="this.media_section == 1 || this.media_section == 2"></el-table-column>
                          <!-- 2023/09/22  #14935 START-->
                          <el-table-column prop="search_word" label="検索語" min-width="140" v-if="this.media_section == 1"></el-table-column>
                          <el-table-column prop="media_type" label="媒体種別" min-width="140" v-if="this.media_section == 2"></el-table-column>
                          <el-table-column prop="other_article" label="その他書誌情報" v-if="this.media_section == 1" min-width="190"></el-table-column>
                          <!-- 2023/09/22  #14935 END-->
                          <el-table-column prop="cover_date" label="号" width="130" v-if="this.media_section == 5"></el-table-column>
                          <el-table-column prop="page" label="ページ" width="140" v-if="this.media_section == 5"></el-table-column>
                          <!-- 2023/09/22  #14935 START-->
                          <el-table-column prop="category" label="雑誌カテゴリ" min-width="190" v-if="this.media_section == 5"></el-table-column>
                          <!-- 2023/09/22  #14935 END-->
                          <el-table-column prop="sales_datetime" label="提供期間" width="200" v-if="this.media_section == 5"></el-table-column>
                          <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                          <!-- 2023/09/22  #14935 START-->
                          <el-table-column prop="search_word" label="検索語" min-width="140" v-if="this.media_section == 2 || this.media_section == 5"></el-table-column>
                          <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                          <el-table-column prop="theme_name" label="テーマ名" min-width="135"></el-table-column>
                          <!-- 2023/09/22  #14935 END-->
                          <el-table-column prop label width="155" v-if="this.media_section == 1">
                            <div class="article-right" slot-scope="scope" >
                              <ul v-if="scope.row.data_section == 1">
                                <li v-if="mc_pdf_view_flag == false || scope.row.no_image_flag == true">
                                  <div class="ico_pdf_Disable" tabindex="0"></div>
                                </li>
                                <li v-else >
                                  <el-tooltip placement="top-start" effect="dark">
                                    <!-- 2021/02/23 #10026 START-->
                                    <!--<el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" slot="content">-->
                                    <el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" slot="content" :arrow="scope.row.image_info.length==1?'never':'hover'">
                                      <!-- 2021/02/23 #10026 END-->
                                      <el-carousel-item :setActiveItem="item" v-for="item in scope.row.image_info" :key="item">
                                        <div style="width: 100px; height: 150px">
                                          <img :src="item" alt="ArticleSnap" @error="replaceByDefault" class="sliderImage" />
                                        </div>
                                      </el-carousel-item>
                                    </el-carousel>
                                    <div class="custom-arrow"></div>
                                    <div @click="sendToErrorDisplay(scope.row.article_id,scope.row.data_section)" class="ico_pdf_upSmall AllNewsico_pdf_upSmall" tabindex="0"></div>
                                  </el-tooltip>
                                </li>
                                <li>
                                  <div @click="sendToCSVDisplay(scope.row.article_id,scope.row.data_section,scope.row.no)" class="ico_csv-output_upSmall" tabindex="0"></div>
                                </li>
                                <li v-if="mc_text_view_flag == false || scope.row.no_text_flag == true">
                                  <div class="ico_text_Disable" tabindex="0"></div>
                                </li>
                                <li v-else>
                                  <div class="ico_text_upSmall" @click="getPdfPrintScreen(scope.row.data_section,scope.row.article_id)" tabindex="0"></div>
                                </li>
                                <li v-if="mc_pdf_print_flag == false || scope.row.no_image_flag == true">
                                  <div class="ico_print_Disable" tabindex="0"></div>
                                </li>
                                <li v-else>
                                  <div class="ico_print_upSmall AllNewsico_print_upSmall" @click="pdfPrint(scope.row.article_id,scope.row.data_section)" tabindex="0"></div>
                                </li>
                              </ul>
                              <ul  v-else-if="scope.row.data_section == 2">
                                <li v-if="sc_pdf_view_flag == false || scope.row.no_image_flag == true">
                                  <div class="ico_pdf_Disable" tabindex="0"></div>
                                </li>
                                <li v-else >
                                  <el-tooltip placement="top-start" effect="dark">
                                    <!-- 2021/02/23 #10026 START-->
                                    <!--<el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" slot="content">-->
                                    <el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" slot="content" :arrow="scope.row.image_info.length==1?'never':'hover'">
                                      <!-- 2021/02/23 #10026 END-->
                                      <el-carousel-item :setActiveItem="item" v-for="item in scope.row.image_info" :key="item">
                                        <div style="width: 100px; height: 150px">
                                          <img :src="item" alt="ArticleSnap" @error="replaceByDefault" class="sliderImage" />
                                        </div>
                                      </el-carousel-item>
                                    </el-carousel>
                                    <div class="custom-arrow"></div>
                                    <div @click="sendToErrorDisplay(scope.row.article_id,scope.row.data_section)" class="ico_pdf_upSmall AllNewsico_pdf_upSmall" tabindex="0"></div>
                                  </el-tooltip>
                                </li>
                                <li>
                                  <div class="ico_csv-output_upSmall_disable" tabindex="0"></div>
                                </li>
                                <li v-if="sc_text_view_flag == false || scope.row.no_text_flag == true">
                                  <div class="ico_text_Disable" tabindex="0"></div>
                                </li>
                                <li v-else>
                                  <div class="ico_text_upSmall" @click="goToThumbnailDisplayScreen(scope.row.article_id,scope.row.data_section,scope.row.no)" tabindex="0"></div>
                                </li>
                                <li v-if="sc_pdf_print_flag == false || scope.row.no_image_flag == true">
                                  <div class="ico_print_Disable" tabindex="0"></div>
                                </li>
                                <li v-else>
                                  <div @click="pdfPrint(scope.row.article_id,scope.row.data_section)"  class="ico_print_upSmall AllNewsico_print_upSmall"  tabindex="0"></div>
                                </li>
                              </ul>
                            </div>
                          </el-table-column>
                        </el-table>
                      </section>
                    </el-tab-pane>
                    <el-tab-pane :label="second_tab_label" name="second">
                      <section>
                        <el-table-draggable>
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                          <el-table 
                          ref="registerTable"
                          :data="getRegisteredRecords"
                          :cell-class-name="tableCellClassName"
                          style="width: 100%" border>
                        <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                            <el-table-column label :min-width="70" :resizable="false">
                              <img
                                class="table-img"
                                src="../../assets/image/two_lines-svg.svg"
                                alt="LOGO"
                              />
                            </el-table-column>
                            <el-table-column width="100" :resizable="false">
                              <!-- <el-button type="primary">削除</el-button> -->
                              <template slot-scope="scope">
                                <el-button v-if="scope.row.theme_name != 'Comment'"
                                  @click.native.prevent="AID0099_DeleteRow(scope.row)"
                                  type="danger"
                                  plain
                                >解除</el-button>
                              </template>
                            </el-table-column>
                            <el-table-column width="100" prop="display_order" label="No" :resizable="false" type="index">
                            </el-table-column>
                            <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                            <!-- 2023/09/22  #14935 START-->
                            <el-table-column prop="title" label="見出し" min-width="460">
                              <!-- 2023/09/22  #14935 END-->
                            <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                             <!--  <template slot-scope="scope">
                                <el-link
                                  type="primary"
                                  :underline="false"
                                  class="ArticleLink"
                                  v-html="scope.row.title"
                                ></el-link>
                                <span class="linkToNextPage"  @click="openPdfConfirmationDialog(scope.row.article_id,scope.row.data_section,scope.row.url)">{{scope.row.title}}</span>
                              </template>-->
                              <template slot-scope="scope" >
                                <div>
                                  <div v-if="scope.row.data_section == 1">
                                    <span v-if="mc_pdf_view_flag == false || scope.row.no_image_flag == true" class="ArticleTitleFor1019" >{{scope.row.title}}</span>
                                    <el-link
                                      v-else
                                      :underline="false"
                                      type="primary"
                                      v-html="scope.row.title"
                                      @click="openPdfConfirmationDialog(scope.row.article_id,scope.row.data_section,scope.row.url)"
                                      class="UserComment"
                                    ></el-link>
                                  </div>
                                  <div v-else-if="scope.row.data_section == 2">
                                    <span v-if="sc_pdf_view_flag == false || scope.row.no_image_flag == true" class="ArticleTitleFor1019">{{scope.row.title}}</span>
                                    <el-link
                                      v-else
                                      :underline="false"
                                      type="primary"
                                      v-html="scope.row.title"
                                      @click="openPdfConfirmationDialog(scope.row.article_id,scope.row.data_section,scope.row.url)"
                                      class="UserComment"
                                    ></el-link>
                                  </div>
                                  <div v-else-if="scope.row.data_section == 3">
                                    <el-link
                                      :underline="false"
                                      type="primary"
                                      v-html="scope.row.title"
                                      @click="openPdfConfirmationDialog(scope.row.article_id,scope.row.data_section,scope.row.url)"
                                      class="UserComment"
                                    ></el-link>
                                  </div>
                                  <div v-else-if="scope.row.data_section == 5">
                                    <el-link v-if="scope.row.sales_datetime_flag == true"
                                      :underline="false"
                                      type="primary"
                                      v-html="scope.row.title"
                                      @click="$gotoEpub(scope.row.contents_id,scope.row.start_page,scope.row.sales_to_datetime)"
                                      class="UserComment"
                                    ></el-link> 
                                    <div v-else-if="scope.row.sales_datetime_flag == false">
                                      {{ scope.row.title }}
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </el-table-column>
                            <!-- 2023/09/22  #14935 START-->
                            <el-table-column min-width="160" label="媒体名" >
                            <!-- 2023/09/22  #14935 START-->
                              <template slot-scope="scope" v-if="scope.row.theme_name != 'Comment'" >
                                <span style v-if="scope.row.data_section == 1">
                                  {{ scope.row.media_name }}
                                  <br />
                                  <img
                                    class="tableInside-img"
                                    src="../../assets/image/logo-new.png"
                                    alt="LOGO"
                                  />
                                </span>
                                <span style v-else-if="scope.row.data_section == 2">
                                  {{ scope.row.media_name }}
                                  <br />
                                  <img
                                    class="tableInside-img"
                                    src="../../assets/image/Nikkie-logo-web.svg"
                                    alt="LOGO"
                                  />
                                </span>
                                <span  style v-else-if="scope.row.data_section == 3">
                                  {{ scope.row.media_name }}
                                  <!-- <img
                                    class="tableInside-img"
                                    src="../../assets/image/logo-new.png"
                                    alt="LOGO"
                                  /> -->
                                </span>
                                <span  style v-else-if="scope.row.data_section == 5">
                                  {{ scope.row.media_name }}
                                </span>
                              </template>
                            </el-table-column>
                            <el-table-column prop="issue_date" label="年月日" width="120" v-if="this.media_section == 1 || this.media_section == 2"></el-table-column>
                            <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                            <!-- 2023/09/22  #14935 START-->
                            <el-table-column prop="search_word" label="検索語" min-width="140" v-if="this.media_section == 1">
                            <!-- 2023/09/22  #14935 END-->
                            <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                              <template slot-scope="scope">
                                <span v-html="scope.row.search_word"></span>
                              </template>
                            </el-table-column>
                            <!-- 2023/09/22  #14935 START-->
                            <el-table-column prop="media_type" label="媒体種別" min-width="140" v-if="this.media_section == 2"></el-table-column>
                            <!-- 2023/09/22  #14935 END-->
                            <!-- 2021/02/07 #10491 START -->
                            <!-- <el-table-column prop="other_article" label="その他書誌情報" width="190" v-if="this.media_section == 1"></el-table-column>
                            <el-table-column prop="theme_name" label="テーマ名">
                            </el-table-column>
                            <el-table-column prop="comment" label="コメント" width="120">
                            </el-table-column> -->
                            <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                            <!-- 2023/09/22  #14935 START-->
                            <el-table-column prop="other_article" label="その他書誌情報" min-width="190" v-if="this.media_section == 1">
                            <!-- 2023/09/22  #14935 END-->
                            <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                              <template slot-scope="scope">
                                <span>{{ scope.row.other_article }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column prop="cover_date" label="号" width="130" v-if="this.media_section == 5"></el-table-column>
                            <el-table-column prop="page" label="ページ" width="140" v-if="this.media_section == 5"></el-table-column>
                            <!-- 2023/09/22  #14935 START-->
                            <el-table-column prop="category" label="雑誌カテゴリ" min-width="190" v-if="this.media_section == 5"></el-table-column>
                            <!-- 2023/09/22  #14935 END-->
                            <el-table-column prop="sales_datetime" label="提供期間" width="200" v-if="this.media_section == 5"></el-table-column>
                            <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                            <!-- 2023/09/22  #14935 START-->
                            <el-table-column prop="search_word" label="検索語" min-width="140" v-if="this.media_section == 2 || this.media_section == 5" class="text-start"></el-table-column>
                            <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                            <el-table-column prop="theme_name" label="テーマ名" min-width="135"></el-table-column>
                            <!-- 2023/09/22  #14935 END-->
                            <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START-->
                            <el-table-column prop="comment" label="コメント" width="120">
                            <!-- 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END-->
                              <template slot-scope="scope">
                                <span class="UserComment" v-html="scope.row.comment"></span>
                              </template>
                            </el-table-column>
                            <!-- 2021/02/07 #10491 END -->
                            <el-table-column  prop label width="155" v-if="this.media_section == 1">
                              <div class="article-right" slot-scope="scope" >
                                <ul v-if="scope.row.data_section == 1">
                                  <li v-if="mc_pdf_view_flag == false || scope.row.no_image_flag == true">
                                    <div class="ico_pdf_Disable" tabindex="0"></div>
                                  </li>
                                  <li v-else>
                                    <el-tooltip placement="top-start" effect="dark">
                                      <!-- 2021/02/23 #10026 START-->
                                      <!--<el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" slot="content">-->
                                      <el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" slot="content" :arrow="scope.row.image_info.length==1?'never':'hover'">
                                        <!-- 2021/02/23 #10026 END-->
                                        <el-carousel-item :setActiveItem="item" v-for="item in scope.row.image_info" :key="item">
                                          <div style="width: 100px; height: 150px">
                                            <img :src="item" alt="ArticleSnap" @error="replaceByDefault" class="sliderImage" />
                                          </div>
                                        </el-carousel-item>
                                      </el-carousel>
                                      <div class="custom-arrow"></div>
                                      <div @click="sendToErrorDisplay(scope.row.article_id,scope.row.data_section)" class="ico_pdf_upSmall AllNewsico_pdf_upSmall" tabindex="0"></div>
                                    </el-tooltip>
                                  </li>
                                  <li>
                                    <div class="ico_csv-output_upSmall" @click="sendToCSVDisplay(scope.row.article_id,scope.row.data_section,scope.row.no)" tabindex="0"></div>
                                  </li>
                                  <li v-if="mc_text_view_flag == false || scope.row.no_text_flag == true">
                                    <div class="ico_text_Disable" tabindex="0"></div>
                                  </li>
                                  <li v-else>
                                    <div class="ico_text_upSmall" @click="getPdfPrintScreen(scope.row.data_section,scope.row.article_id)" tabindex="0"></div>
                                  </li>
                                  <li v-if="mc_pdf_print_flag == false || scope.row.no_image_flag == true">
                                    <div class="ico_print_Disable" tabindex="0"></div>
                                  </li>
                                  <li v-else>
                                    <div class="ico_print_upSmall AllNewsico_print_upSmall" @click="pdfPrint(scope.row.article_id,scope.row.data_section)" tabindex="0"></div>
                                  </li>
                                </ul>
                                <ul v-else-if="scope.row.data_section == 2">
                                  <li v-if="sc_pdf_view_flag == false || scope.row.no_image_flag == true">
                                    <div class="ico_pdf_Disable" tabindex="0"></div>
                                  </li>
                                  <li v-else>
                                    <el-tooltip placement="top-start" effect="dark">
                                      <!-- 2021/02/23 #10026 START-->
                                      <!--<el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" slot="content">-->
                                      <el-carousel height="150px" style="width: 100px" class="tooltipInsideCarousel" :autoplay="true" slot="content" :arrow="scope.row.image_info.length==1?'never':'hover'">
                                        <!-- 2021/02/23 #10026 END-->
                                        <el-carousel-item :setActiveItem="item" v-for="item in scope.row.image_info" :key="item">
                                          <div style="width: 100px; height: 150px">
                                            <img :src="item" alt="ArticleSnap" @error="replaceByDefault" class="sliderImage" />
                                          </div>
                                        </el-carousel-item>
                                      </el-carousel>
                                      <div class="custom-arrow"></div>
                                      <div @click="sendToErrorDisplay(scope.row.article_id,scope.row.data_section)" class="ico_pdf_upSmall AllNewsico_pdf_upSmall" tabindex="0"></div>
                                    </el-tooltip>
                                  </li>
                                  <li>
                                    <div class="ico_csv-output_upSmall_disable" tabindex="0"></div>
                                  </li>
                                  <li v-if="sc_text_view_flag == false || scope.row.no_text_flag == true">
                                    <div class="ico_text_Disable" tabindex="0"></div>
                                  </li>
                                  <li v-else>
                                    <div class="ico_text_upSmall" @click="goToThumbnailDisplayScreen(scope.row.article_id,scope.row.data_section,scope.row.no)" tabindex="0"></div>
                                  </li>
                                  <li v-if="sc_pdf_print_flag == false || scope.row.no_image_flag == true">
                                    <div class="ico_print_Disable" tabindex="0"></div>
                                  </li>
                                  <li v-else>
                                    <div @click="pdfPrint(scope.row.article_id,scope.row.data_section)"  class="ico_print_upSmall AllNewsico_print_upSmall"  tabindex="0"></div>
                                  </li>
                                </ul>
                              </div>
                            </el-table-column>
                          </el-table>
                        </el-table-draggable>
                      </section>
                    </el-tab-pane>
                  </el-tabs>
                </section>
              </div>
            </pane>
            <pane class="SideBarRight">
              <SideBar class="SidePane" />
            </pane>
          </splitpanes>
        </el-container>
      </div>

      <el-container class="footer-div">
        <el-footer class="footer-element">
          <FooterComponent />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
const newArr = {};
var CurrentYear = new Date().getFullYear();
var CurrentMonth = new Date().getMonth();
var CurrentDay = new Date().getDate();
var FifteendaysBefore = CurrentDay;
import Vue from "vue";
import Header from "../common/header.vue";
import SideBar from "../common/side-bar.vue";
import FooterComponent from "../common/footerComponent.vue";
import { mapGetters } from "vuex";
import { Splitpanes, Pane } from "splitpanes";
import ElTableDraggable from "element-ui-el-table-draggable";
import json from "../../components/config.json";
import "splitpanes/dist/splitpanes.css";
import error_image from "../../assets/image/errorThumbnail@3_200x200.png";
import router from '../../router';
export default {
  name: "SearchConditionRegScreen",
  components: {
    Header,
    SideBar,
    FooterComponent,
    Splitpanes,
    Pane,
    ElTableDraggable
  },
  data() {
    return {
      // 2022/09/12  #13561  START
      Buttonpressed: 0,
      // 2022/09/12  #13561  END
      /*****1572 related fix****/
      AID0071_InputParams: "",
      AID0046_InputParams: "",
      form: {
        input1 : '',
        input2 : '',
      },
      countSort:'',
      articleid_array:'',
      alert_medianame:'',
      contractId:'',
      alert_keyword:'',
      second_tab_label: '並び替え(0件)',
      rules: {
        input1: [
            { required: true, message: 'メディア名を選択してください' }
        ],
        input2:[
          { required: true, message: 'キーワードは500文字以下を入力してください。' },
          { max: 500, message: "キーワードは500文字以下を入力してください。" }
        ]
      },
      loading: true,
      secondtab_loading : true,
      input1: "",
      input2: "",
      value1: "検索条件から選択",
      activeName: "first",
      sample_data:[],
      clickable: false,
      date: {
          start: new Date(CurrentYear, CurrentMonth, CurrentDay), // Jan 16th, 2018
          end:  new Date(CurrentYear, CurrentMonth, FifteendaysBefore),// Jan 19th, 2018
        },
      multipleSelection: [],
      getdropdownForThemes:[
        {
          value: 'ThemeA',
          label: '1'
        },
        {
          value: 'ThemeB',
          label: '2'
        }
      ],
      theme_name:'',
      startDate:'',
      endDate:'',
      NewsArticle:[],
      media_section : '',
      articlecount: 0,
      mc_pdf_view_flag: '',
      mc_pdf_print_flag: '',
      mc_text_view_flag: '',
      mc_text_print_flag: '',
      sc_pdf_view_flag: '',
      sc_pdf_print_flag: '',
      sc_text_view_flag: '',
      sc_text_print_flag: '',
      process_date : '',
      today_date : '',
      topics_id: '',
      pdf_confirm_message_flag:'',
      text_confirm_message_flag:'',
      print_confirm_message_flag:'',
      userId:'',
      theme_browsing:false,
      user_group_name: '',
      topic_id_1020:'',
      contract_kbn: '',
      theme_name_id:'',
      fullscreenLoading: false,
      // 2021/11/18  #12035  START
      staticArrayForDelete: [],
      // 2021/11/18  #12035  END
      // 2022/03/28  #12564  START
      staticArrayForSecondTabRegistered: [],
      // 2022/03/28  #12564  END
      /*** Change by AJ for backlog Id: 1509 */
      staticArrayForSecondTab: []
      /*** Change by AJ for backlog Id: 1509 */
    };
  },
  
  methods: {
    replaceByDefault(event) {
      event.target.src = error_image;
    },
    OnLoad(){
      
      // Session values will be taken from session and from 1019-001 parameters
      this.topic_id_1020=this.$route.params.secondScreen.topics_id;

      // Empty the articleid list 
      this.articleid_array = ''; 
      // Article count value should be zero when page loads
      this.articlecount = 0;

      Vue.prototype.$session.set('media',this.$route.params.secondScreen.media);

      this.userId = this.getUserId
      this.theme_browsing = this.getThemeBrowsing
      //get the user_group_name value from session
      this.user_group_name = this.getUserGroupName;
      this.mc_pdf_view_flag = this.getMC_Pdf_View_Flag
      this.mc_pdf_print_flag = this.getMC_Pdf_Print_Flag
      this.mc_text_view_flag = this.getMC_Text_View_Flag
      this.mc_text_print_flag = this.getMC_Text_Print_Flag

      this.sc_pdf_view_flag = this.getSC_Pdf_View_Flag
      this.sc_pdf_print_flag = this.getSC_Pdf_Print_Flag
      this.sc_text_view_flag = this.getSC_Text_View_Flag
      this.sc_text_print_flag = this.getSC_Text_Print_Flag

      var message_info = this.getMessageInfo

      for(var u=0;u<message_info.length;u++)
      {
        if(message_info[u].message_key == "demandConfirmPdfMessage")
        {
          this.pdf_confirm_message_flag = message_info[u].configuration_value
        }
        else if(message_info[u].message_key == "demandConfirmTextMessage")
        {
          this.text_confirm_message_flag = message_info[u].configuration_value
        }
        else if(message_info[u].message_key == "demandConfirmPrintMessage")
        {
          this.print_confirm_message_flag = message_info[u].configuration_value
        }
        else
        {
          //no action needed
        }
      }

      //get the contract_id value from session
      this.contractId = this.getContractId

      // Setting the today's date for process_date_from and process_date_to
      var new_date = new Date(),
          get_month = ("0" + (new_date.getMonth() + 1)).slice(-2),
          get_day = ("0" + new_date.getDate()).slice(-2);
      var today_date = [new_date.getFullYear()+'-',get_month+'-',get_day].join("");

      // date saved for parameters passing - Format('yyyy/mm/dd')
      var process_date_0099 = [new_date.getFullYear()+'/',get_month+'/',get_day].join("");
      
      this.today_date = process_date_0099;

      this.process_date = today_date;

      var topicsid = this.$route.params.secondScreen.topics_id;
      this.topics_id = topicsid;

      this.userId = this.getUserId;

      if(this.$route.params.secondScreen.media == '新聞'){
        this.media_section = 1;
        this.contract_kbn = 1;
      }else if(this.$route.params.secondScreen.media == '雑誌'){
        this.media_section = 5;
        this.contract_kbn = 5;
      }else{
        this.media_section = 2;
        this.contract_kbn = 2;
      }


      this.articlecount = this.getArticleCount;

      // 2019年12月21日から2019年12月21日
      var startingDateForSpan=this.date.start;
      var splitData = new Date(startingDateForSpan),
          splitmonth = ("0" + (splitData.getMonth() + 1)).slice(-2),
          splitday = ("0" + splitData.getDate()).slice(-2);
      var startResult = [splitData.getFullYear()+'年', splitmonth+'月', splitday+'日'].join("");
  
      this.startDate=startResult;
        //To get the end date
      var getlastDateForSpan=this.date.end;
      var splitDataLast = new Date(getlastDateForSpan),
          splitmonthlast = ("0" + (splitDataLast.getMonth() + 1)).slice(-2),
          splitdaylast = ("0" + splitDataLast.getDate()).slice(-2);
      
      var startResultlast = [splitData.getFullYear()+'年', splitmonthlast+'月', splitdaylast+'日'].join("");

      
      this.endDate=startResultlast;

      // Default records selection box check functionality
      // If the table records (First tab) are already registered
      // THose records will be selected by default
      // Theme dropdown 
      this.AID0007_ThemeDropdown();
      // Hit AID0046 for today's date

      // AID0072 Dropdown - 検索条件から選択
      this.AID0072_DropDown();

      // Hit AID0071 for today's date
      // Returns if the records available for today's date
      this.AID0071_PageLoad();   
      
      // Returns if the records are registered for today's date
      this.Aid0046_Get('AID0046_OnLoad');   
      
    },
    AID0072_DropDown(){
      
      
      var AID0072_Parameters = {
            contract_id: this.contractId,
            user_id: this.userId,
            theme_browsing: this.theme_browsing,
            display_id: 'SID1019',
            topics_id: this.topics_id
        }
      this.$store.dispatch('communication1019002/AID0072_DropDown',AID0072_Parameters);

    },
    async AID0071_PageLoad(){
      var setFirstTableEmpty = [];
      // Set Empty table records
      this.$store.commit('situation1019002/getFirstTable', setFirstTableEmpty); 
      this.$store.commit('situation1019002/getArticleCount',0);
      
      // Onload Parameters For AID0071 
      var AID0071_OnLoad_Parameters = {           
          user_id: this.userId,  
          topics_id: this.topics_id,      
          process_date_from : this.process_date,
          process_date_to : this.process_date,
          display_id: 'SID1019',
          contract_kbn: this.contract_kbn,            
          theme_browsing: this.theme_browsing            
      };

      this.$store.dispatch('communication1019002/AID0071_OnLoad',AID0071_OnLoad_Parameters).then(()=>{

       
        this.articlecount = this.getArticleCount;

      });

    },
    AID0007_ThemeDropdown(){
      
      var AID0007_InputParameters = {
        contract_id: this.contractId,
        user_id: this.userId,
        theme_browsing: this.theme_browsing,
        display_id: 'SID1019',
        topics_id: this.topics_id
      }
      this.$store.dispatch('communication1019002/AID0007_DropDown',AID0007_InputParameters);

    },
    openPdfConfirmationDialog(articleId,datasection,url){
    this.$LogButtonEvent("1019-002","OpenDialog");
    this.$LogMethodIN("1019-002","openPdfConfirmationDialog");
    // For Web news article the link redirectly open in new tab
    // For MC & SC article go for pdf 
    if(datasection == 3){
      
      window.open(url, '_blank');

    }
      else{
      var pdfValues = {
        pdf_flag: 1,
        article_info:[
          {
            article_id: articleId,
            data_section: datasection
          }
        ],
        user_id:this.userId,
        contract_code:this.getContractCode,
        theme_browsing:this.theme_browsing,
        display_id:"SID1019",
        is_mail:false
      };
      var printSuccessValues = {
        data_info:[{
        contract_id: this.contractId,
        data_section: datasection,
        user_id: this.userId,
        read_count:1,
        request_div:1,
        article_id: articleId,
        user_group_name: this.user_group_name,
        
        }],
        is_mail:false
      }
      var printCombinedArray = [];

      printCombinedArray = [...printCombinedArray, pdfValues, printSuccessValues];
      if(this.getOut_Demand_Confirm_Message_Div_Flag)
      {
        this.$confirm(this.getDemandConfirmPdfMessage,"確認",
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            beforeClose: (action, instance, done) => {
              if(action === "confirm"){
                /*******BT08460_EXTERNAL-1539 issue fix*******/
                this.$session.set('pdfCombinedArray', printCombinedArray);
                let routeData = this.$router.resolve({name: '0001-001'}); 
                window.open(routeData.href, '_blank');
                /*this.fullscreenLoading = true;
                this.$store.dispatch('communication0004/getPdfDisplay', printCombinedArray).then(() => {
                this.fullscreenLoading = false;
                })
                .catch(() => {
                  this.fullscreenLoading = false;
                })*/
                /*******BT08460_EXTERNAL-1539 issue fix*******/
                done();
              }else{
                done();
              }
            }
          }
        );
      }
      else
      {
        /*******BT08460_EXTERNAL-1539 issue fix*******/
        this.$session.set('pdfCombinedArray', printCombinedArray);
        let routeData = this.$router.resolve({name: '0001-001'}); 
        window.open(routeData.href, '_blank');
        /*this.fullscreenLoading = true;
        this.$store.dispatch('communication0004/getPdfDisplay', printCombinedArray).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })*/
        /*******BT08460_EXTERNAL-1539 issue fix*******/
      }
    }
    this.$LogMethodOut("1019-002","openPdfConfirmationDialog");
    },
    sendToErrorDisplay(articleid,data_section){
      this.$LogButtonEvent("1019-002","Showpdf");
      this.$LogMethodIN("1019-002","sendToErrorDisplay");
      var pdfValues = {
        pdf_flag: 1,
        article_info:[
          {
            article_id: articleid,
            data_section: data_section
          }
        ],
        user_id:this.userId,
        contract_code:this.contractId.toString(),
        theme_browsing: this.theme_browsing,
        display_id:"SID1019",
        is_mail:false
      };
       var pdfSuccessValues = {
        data_info:[{
        contract_id: this.contractId,
        data_section: data_section,
        user_id: this.userId,
        read_count:1,
        request_div:1,
        article_id: articleid,
        user_group_name: this.user_group_name,
        
        }],
        is_mail:false
      }
      var pdfCombinedArray = [];

      pdfCombinedArray = [...pdfCombinedArray, pdfValues, pdfSuccessValues];

      if(this.getOut_Demand_Confirm_Message_Div_Flag)
      {
        this.$confirm(this.getDemandConfirmPdfMessage,"確認",
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            beforeClose: (action, instance, done) => {
              if(action === "confirm"){
                /*******BT08460_EXTERNAL-1539 issue fix*******/
                this.$session.set('pdfCombinedArray', pdfCombinedArray);
                let routeData = this.$router.resolve({name: '0001-001'}); 
                window.open(routeData.href, '_blank');
                /*
                this.fullscreenLoading = true;
                this.$store.dispatch('communication0004/getPdfDisplay', pdfCombinedArray).then(() => {
                  this.fullscreenLoading = false;
                })
                .catch(() => {
                  this.fullscreenLoading = false;
                })*/
                /*******BT08460_EXTERNAL-1539 issue fix*******/
                done();
              }else{
                done();
              }
            }
          }
        );
      }
      else
      {
        /*******BT08460_EXTERNAL-1539 issue fix*******/
        this.$session.set('pdfCombinedArray', pdfCombinedArray);
        let routeData = this.$router.resolve({name: '0001-001'}); 
        window.open(routeData.href, '_blank');
        /*this.fullscreenLoading = true;
        this.$store.dispatch('communication0004/getPdfDisplay', pdfCombinedArray).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })*/
        /*******BT08460_EXTERNAL-1539 issue fix*******/
      }
      this.$LogMethodOut("1019-002","sendToErrorDisplay");
    },
    sendToCSVDisplay(article_id,data_section,no){
      /*****1572 related fix****/
      if(this.activeName == "first"){
        Vue.prototype.$session.set('InputParameterFor0006',this.AID0071_InputParams);
        Vue.prototype.$session.set('CurrentAID',"0071");
        //2025/07/09  #19462  START
        this.$session.set('CurrentRowNo', no - 1);
      }else{
        var second_tab_tabledata = this.$refs.registerTable.tableData;
        var second_tab_tabledata_length = second_tab_tabledata.length;
        console.log('second_tab_tabledata: ', second_tab_tabledata);
        var ArticleInfoArray = [];

        for(var i=0;i<second_tab_tabledata_length;i++){
          var data_section1 = second_tab_tabledata[i].data_section;
          var article_id1 = second_tab_tabledata[i].article_id;
          if(second_tab_tabledata[i].article_id == article_id){
            this.$session.set('CurrentRowNo', i);
          }
          ArticleInfoArray=[...ArticleInfoArray,{article_id: article_id1, data_section: data_section1 } ]
        }

        var AID1019_InputParams = {
                    Article_info :ArticleInfoArray,
                    theme_id : this.theme_name_id,
                    image_flag :true
                };
        Vue.prototype.$session.set('InputParameterFor0006',AID1019_InputParams);
        Vue.prototype.$session.set('CurrentAID',"0109");
      }
      this.$LogButtonEvent("1019-002","CsvDisplay");
      this.$LogMethodIN("1019-002","sendToCSVDisplay");
      this.$session.set('Article_Id', article_id);
      //this.$session.set('CurrentRowNo', no - 1);
      //2025/07/09  #19462  END

      //if data_section value is 1, redirect to SID0006 page
      if(data_section == 1){
        let routeData = this.$router.resolve({name: '0006'}); 
        window.open(routeData.href, '_blank');
      }else if(data_section == 2){ //if data_section value is 2, redirect to SID0007 page
        let routeData = this.$router.resolve({name: '0007'}); 
        window.open(routeData.href, '_blank');
      }
      this.$LogMethodOut("1019-002","sendToCSVDisplay");
    },
    getPdfPrintScreen(data_section,articlieid){
      this.$LogButtonEvent("1019-002","Showpdfprintscreen");
      this.$LogMethodIN("1019-002","getPdfPrintScreen");

      var articleDetails = {
        articleId: articlieid,
        data_section: data_section,        
        printOption: true,
        is_mail:false,
        display_id:"SID1019"
      };
      
      if(this.getOut_Demand_Confirm_Message_Div_Flag)
      {
        this.$confirm(this.getDemandConfirmTextMessage,"確認",
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: "キャンセル",
            beforeClose: (action, instance, done) => {
              if(action === "confirm")
              {
                let routeData = this.$router.resolve({name: '0008', query: articleDetails}); 
                window.open(routeData.href, '_blank');
                done();
              }
              else
              {
                done();
              }
            }
          }
        );
      }
      else
      {
        let routeData = this.$router.resolve({name: '0008', query: articleDetails}); 
        window.open(routeData.href, '_blank');
      }
       
    },   
    //2025/05/21  #19462  START
    goToThumbnailDisplayScreen(article_id,data_section,no){
      /*****1572 related fix****/
      if(this.activeName == "first"){
        Vue.prototype.$session.set('InputParameterFor0006',this.AID0071_InputParams);
        Vue.prototype.$session.set('CurrentAID',"0071");
        this.$session.set('CurrentRowNo', no-1);
      }else{
        var second_tab_tabledata = this.$refs.registerTable.tableData;
        var second_tab_tabledata_length = second_tab_tabledata.length;
        console.log('second_tab_tabledata: ', second_tab_tabledata);
        var ArticleInfoArray = [];

        for(var i=0;i<second_tab_tabledata_length;i++){
          var data_section1 = second_tab_tabledata[i].data_section;
          var article_id1 = second_tab_tabledata[i].article_id;
          if(second_tab_tabledata[i].article_id == article_id){
            this.$session.set('CurrentRowNo', i);
          }
          ArticleInfoArray=[...ArticleInfoArray,{article_id: article_id1, data_section: data_section1 } ]
        }

        var AID1019_InputParams = {
                    Article_info :ArticleInfoArray,
                    theme_id : this.theme_name_id,
                    image_flag :true
                };
        Vue.prototype.$session.set('InputParameterFor0006',AID1019_InputParams);
        Vue.prototype.$session.set('CurrentAID',"0109");
      }

      this.$LogButtonEvent("1019-002","DisplayThumbnail");
      this.$LogMethodIN("1019-002","goToThumbnailDisplayScreen");
      this.$session.set('Article_Id', article_id);
      //this.$session.set('CurrentRowNo', no-1);
      this.$session.set('CurrentNewsCount', second_tab_tabledata_length);
      //2025/05/21  #19462  END

      this.$session.set('CurrentSID', "1019");
      if(data_section == 1){
        let routeData = this.$router.resolve({name: '0006'}); 
        window.open(routeData.href, '_blank');
      }else if(data_section == 2){
        let routeData = this.$router.resolve({name: '0007'}); 
        window.open(routeData.href, '_blank');
      }
      this.$LogMethodOut("1019-002","goToThumbnailDisplayScreen");
    },
    pdfPrint(articleid,datasection){
      this.$LogButtonEvent("1019-002","PrintPdf");
      this.$LogMethodIN("1019-002","pdfPrint");
      var pdfValues = {
        pdf_flag:2,
        article_info:[
          {
            article_id: articleid,
            data_section: datasection
          }
        ],
        user_id:this.userId,
        contract_code:this.contractId.toString(),
        theme_browsing:this.theme_browsing,
        display_id:"SID1019"
      }
      var printSuccessValues = {
        data_info:[{
          contract_id: this.contractId,
          data_section: datasection,
          user_id: this.userId,
          read_count:1,
          request_div:2,
          article_id: articleid,
          user_group_name: this.user_group_name,
        }],
        is_mail:false
      }
      var printCombinedArray = [];

      printCombinedArray = [...printCombinedArray, pdfValues, printSuccessValues];

      if(this.getOut_Demand_Confirm_Message_Div_Flag)
      {
        this.$confirm(this.getDemandConfirmPrintMessage,"確認",
        {
          showCancelButton: true,
          confirmButtonText: "OK",
          cancelButtonText: "キャンセル",
          beforeClose: (action, instance, done) => {
            if(action === "confirm")
            {
              this.fullscreenLoading = true;
              this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
                  this.fullscreenLoading = false;
                })
                .catch(() => {
                  this.fullscreenLoading = false;
                })
              done();
            }
            else
            {
              done();
            }
          }
        });
      }
      else{
        this.fullscreenLoading = true;
        this.$store.dispatch('communication0004/getPdfPrint', printCombinedArray).then(() => {
          this.fullscreenLoading = false;
        })
        .catch(() => {
          this.fullscreenLoading = false;
        })
      }
      this.$LogMethodOut("1019-002","pdfPrint");
    },
    toggleSelection(rows){
        this.$refs.multipleTable.clearSelection();
        if(rows){

          var first_records = this.getTableResult1019002;
          var artilcelist = [];

          var rows_article_id_array = [];
          for (var k=0; k < rows.length; k++) {
            rows_article_id_array.push(rows[k].article_id);
          }

          for(var i=0;i<rows_article_id_array.length;i++){
            for(var j=0;j<first_records.length;j++){
              if(rows_article_id_array[i] == first_records[j].article_id){
            
                artilcelist.push(first_records[j].article_id);

                this.$refs.multipleTable.toggleRowSelection(first_records[j]);
              }
             
            }
          }
          this.articleid_array = artilcelist;
          
          this.loading = false;
        }
        else{
          this.loading = false;

        }
    }, 
    
      Goto_SID1019_001() {
      this.$LogButtonEvent("1019-002","Cancellation");
      this.$LogMethodIN("1019-002","Goto_SID1019_001");
        this.$confirm(
          json["1019-002_stop_message"],
          json["1019_002_stop_message_title"],
          {
            showCancelButton: true,
            cancelButtonText: "キャンセル",
            confirmButtonText: "OK",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                router.push({
                  name: "1019-001"
                })
                done();
              } else {
                done();
              }
            }
          }
        );
        this.$LogMethodOut("1019-002","Goto_SID1019_001");
      },
      AID0047_Add() {
               
      this.$LogButtonEvent("1019-002","TopicRegistration");
      this.$LogMethodIN("1019-002","AID0047_Add");

        var registered_records_length = this.getRegisteredRecords.length;
        /*** Change by DK for backlog Id: 1561 */
        var clip_Date = this.$route.params.secondScreen.date;
        if(this.$route.params.secondScreen.date)
        {
          clip_Date = this.$route.params.secondScreen.date.split('/').join('-');
        }

        if(registered_records_length == 0){
          
          if(this.multipleSelection.length != 0){
          
                var newsArticle = this.NewsArticle;
               
                var mediasection = 1;
                if(this.$route.params.secondScreen.media == '新聞'){
            
                  mediasection = 1;
                }else if(this.$route.params.secondScreen.media == '雑誌'){
            
                  mediasection = 5;
                }else{
          
                  mediasection = 2;
                }
                var AID0047_InputParameters = {
                    topics_id : newsArticle[0].topics_id,
                    media_section: mediasection,
                    /*** Change by DK for backlog Id: 1561 */
                    process_date : clip_Date,
                    topics_article_info : newsArticle[0].topics_article_info
                };
              if(AID0047_InputParameters.length != 0){
                  this.$store.dispatch('communication1019002/AID0047_Add',AID0047_InputParameters).then(() =>{
                  var status = this.getResponse
                  if(status != 1){
                    router.push({name: "1020",params: {date: this.$route.params.secondScreen.date, title:this.$route.params.secondScreen.title,medium:this.$route.params.secondScreen.media,topic_id:this.topic_id_1020}});
                  }
                  else{
                    this.$confirm(
                      json["1019-002_topic_register_failure_message"],
                      json["1019-002_topic_register_failure_message_title"],
                      {
                        showCancelButton: false,
                        confirmButtonText: "OK",
                        beforeClose: (action, instance, done) => {
                          if (action === "confirm") {
                            
                            done();
                          } else {
                            done();
                          }
                        }
                      }
                    );
                  }
                });
              }
            }
            else{
              this.$alert("登録したい記事を選択してください。", null, {
                confirmButtonText: 'OK',
              });	
            }
        }
        else{
          
          if(this.multipleSelection.length == 0){

            var second_tab_tabledata = this.$refs.registerTable.tableData;
            
            var second_tab_tabledata_length = second_tab_tabledata.length;

            var AID0047_InputParameters_SecondData = {
                topics_id : this.topics_id,
                /*** Change by DK for backlog Id: 1561 */
                process_date : clip_Date,
                topics_article_info :[]
            };
            for(var i=0;i<second_tab_tabledata_length;i++){
              var topics_info = {};
                topics_info.data_section = second_tab_tabledata[i].data_section;
                topics_info.article_id = second_tab_tabledata[i].article_id;
                topics_info.display_order = i + 1;
                
                AID0047_InputParameters_SecondData.topics_article_info.push(topics_info);
            }
            this.$store.dispatch('communication1019002/AID0047_Add',AID0047_InputParameters_SecondData).then(() =>{
                  var status = this.getResponse
                  if(status != 1){
                    router.push({name: "1020",params: {date: this.$route.params.secondScreen.date, title:this.$route.params.secondScreen.title,medium:this.$route.params.secondScreen.media,topic_id:this.topic_id_1020}});
                  }
                  else{
                    this.$confirm(
                      json["1019-002_topic_register_failure_message"],
                      json["1019-002_topic_register_failure_message_title"],
                      {
                        showCancelButton: false,
                        confirmButtonText: "OK",
                        beforeClose: (action, instance, done) => {
                          if (action === "confirm") {
                            
                            done();
                          } else {
                            done();
                          }
                        }
                      }
                    );
                  }
                });
          }
          else{

            
           
            var registered_tabledata = this.$refs.registerTable.tableData;

            
            var AID0047_InputParameters_ForTwoSides = {
                topics_id : this.topics_id,
                /*** Change by DK for backlog Id: 1561 */
                process_date : clip_Date,
                topics_article_info :[]
            };
            

            for(i=0;i<registered_tabledata.length;i++){
              var secondtab_inner_array = {};
              secondtab_inner_array.data_section = registered_tabledata[i].data_section;
              secondtab_inner_array.article_id = registered_tabledata[i].article_id;
              secondtab_inner_array.display_order = parseInt(i + 1);

              AID0047_InputParameters_ForTwoSides.topics_article_info.push(secondtab_inner_array);

            }
           
            this.$store.dispatch('communication1019002/AID0047_Add',AID0047_InputParameters_ForTwoSides).then(() =>{
              var status = this.getResponse
              if(status != 1){
                router.push({name: "1020",params: {date: this.$route.params.secondScreen.date, title:this.$route.params.secondScreen.title,medium:this.$route.params.secondScreen.media,topic_id:this.topic_id_1020}});
              }
              else{
                this.$confirm(
                  json["1019-002_topic_register_failure_message"],
                  json["1019-002_topic_register_failure_message_title"],
                  {
                    showCancelButton: false,
                    confirmButtonText: "OK",
                    beforeClose: (action, instance, done) => {
                      if (action === "confirm") {
                        
                        done();
                      } else {
                        done();
                      }
                    }
                  }
                );
              }
            });
            
          }
        }

      

        
        this.$LogMethodOut("1019-002","AID0047_Add");
        
      },
      AID0099_DeleteAll() {

      this.$LogButtonEvent("1019-002","Delete");
      this.$LogMethodIN("1019-002","AID0099_DeleteAll");

        this.$confirm(
          json["1019-002_delete_topic_confirm_message_01"],
          json["1019-002_delete_topic_confirm_message_title"],
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: 'キャンセル',
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
   
                var Delete_Temporary_SecondTab_Data = [];
                /*
                * Backlog issue related fix
                * Author: BM
                * Backlog Id: BT08460_EXTERNAL-1633
                * In the case of a future day, deletion failure
                */
                var clip_Date_DELETE = this.$route.params.secondScreen.date;
                if(this.$route.params.secondScreen.date)
                {
                  clip_Date_DELETE = this.$route.params.secondScreen.date.split('/').join('-');
                }
                // Form Input parameters for delete AID0099
                var AID0099_InputParameters = {
                  topics_id : this.topics_id,
                  process_date:clip_Date_DELETE,
                  articles : [],
                };
  
                //var delete_articles = this.getRegisteredRecords;
                // 2021/11/18  #12035  START
                //var delete_articles = this.getRegisteredRecordsForDelete;
                var delete_articles = JSON.parse(this.staticArrayForDelete);
                // 2021/11/18  #12035  END
                if((delete_articles != null && delete_articles != ""))
                {

                  for(var i=0; i<delete_articles.length;i++){
                  
                    var articles ={};

                    articles.data_section = delete_articles[i].data_section;
                    articles.article_id = delete_articles[i].article_id;
                    
                    AID0099_InputParameters.articles.push(articles);
                    
                  }

                  this.$store.dispatch("communication1019002/AID0099_Delete",AID0099_InputParameters).then(() =>{
                      
                      this.$alert(this.getMsgDetail, "確認", {
                        confirmButtonText: 'OK',
                      }).then(() =>{
                        if(this.getResponse == 0 && this.getResponse == "0"){
                        
                          
                          this.$store.commit('situation1019002/SID1019_RegisteredRecords_ForDelete', Delete_Temporary_SecondTab_Data); 
                          this.Aid0046_Get('AID0046_Delete');
                        }
                        
                      });	

                  });

                }
                else if(this.getRegisteredRecords.length == 0){
                  /*** Changes by SJ for backlog Id: 1782 */
                  this.Aid0046_Get('AID0046_Delete');

                }
                else{
                    // 2021/11/13  #12035  START
                    this.staticArrayForSecondTab = Delete_Temporary_SecondTab_Data;
                    // 2021/11/13  #12035  END
                    // 2022/03/28  #12564  START
                    this.staticArrayForSecondTabRegistered = JSON.parse(JSON.stringify(Delete_Temporary_SecondTab_Data));
                    // 2022/03/28  #12564  END
                    // Deleting the Temporary and registered records.
                    this.$store.commit('situation1019002/SID1019_RegisteredRecords_ForDelete', Delete_Temporary_SecondTab_Data); 
                    this.$store.commit('situation1019002/SID1019_RegisteredRecords', this.Delete_Temporary_SecondTab_Data); 
                    // Second tab label value change after delete
                    this.second_tab_label = this.second_tab_label = "並び替え(0件)";
                    this.$nextTick(function(){
                      this.toggleSelection(this.getRegisteredRecords);
                    });
                }
                done();
              } else {
              
                done();
              }
            }
          }
        );
      this.$LogMethodOut("1019-002","AID0099_DeleteAll");
        
      },
      AID0099_DeleteRow(index) {

        this.$LogButtonEvent("1019-002","DeleteRow");
        this.$LogMethodIN("1019-002","AID0099_DeleteRow");
       
        this.$confirm(
          json["1019-002_confirm_message_01"],
          json["1019-002_delete_topic_confirm_message_title"],
          {
            showCancelButton: true,
            confirmButtonText: "OK",
            cancelButtonText: 'キャンセル',
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {

                var delete_particular = this.getRegisteredRecords;
                
                
                for(var i=0;i<delete_particular.length;i++){
                  if(delete_particular[i].article_id == index.article_id){
                    delete_particular.splice(i,1);
                  }
                }
                
                // 2021/11/13  #12035  START
                this.staticArrayForSecondTab=this.getRegisteredRecords;
                // 2021/11/13  #12035  END
                // 2022/03/28  #12564  START
                this.staticArrayForSecondTabRegistered = JSON.parse(JSON.stringify(this.getRegisteredRecords));
                // 2022/03/28  #12564  END
                this.$store.commit('situation1019002/SID1019_RegisteredRecords', this.getRegisteredRecords); 
                this.second_tab_label = this.second_tab_label = "並び替え("+ this.getRegisteredRecords.length + "件)";
                 
                this.$nextTick(function(){
                  this.toggleSelection(this.getRegisteredRecords);
                });

                
                done();
              } else {
            
                done();
              }
            }
          }
        );
        this.$LogMethodOut("1019-002","AID0099_DeleteRow");
      },
      AID0071_Search(){
        this.$LogButtonEvent("1019-002","SearchArticle");
        this.$LogMethodIN("1019-002","AID0071_Search");
        /*** Change by AJ for backlog Id: 1509 */
        this.staticArrayForSecondTab = this.getRegisteredRecords;
        /*** Change by AJ for backlog Id: 1509 */
        // 2022/03/28  #12564  START
        this.staticArrayForSecondTabRegistered = JSON.parse(JSON.stringify(this.getRegisteredRecords));
        // 2022/03/28  #12564  END
        // Article count should be 0 when search button clicks
        this.articlecount = 0;
        var setFirstTableEmpty = [];
        // Set Empty table records
        this.$store.commit('situation1019002/getFirstTable', setFirstTableEmpty); 
        this.$store.commit('situation1019002/getArticleCount',0);
        
        var input1 = this.input1;
        var input2 = this.input2;
        if(input1 != '' && input1.length > 500){
          this.alert_medianame = '';
          this.alert_keyword = '';
          this.$alert("キーワードは500文字以下を入力してください。", null, {
            confirmButtonText: 'OK',
          });	
        }
        else if(input2 != '' && input2.length > 100 ){
          this.alert_keyword = '';
          this.alert_medianame = '';
          this.$alert("媒体名は100文字以下を入力してください。", null, {
            confirmButtonText: 'OK',
          });	
        }
        else{
            
          this.alert_keyword = '';
          this.alert_medianame = '';

          this.loading = true;
          //To get the start date
          var startingDate=this.date.start;
          var splitData = new Date(startingDate),
              splitmonth = ("0" + (splitData.getMonth() + 1)).slice(-2),
              splitday = ("0" + splitData.getDate()).slice(-2);
          var startResult = [splitData.getFullYear(), splitmonth, splitday].join("/");
          var getlastDate=this.date.end;
          var splitDataLast = new Date(getlastDate),
              splitmonthlast = ("0" + (splitDataLast.getMonth() + 1)).slice(-2),
              splitdaylast = ("0" + splitDataLast.getDate()).slice(-2);
          var startResultlast = [splitDataLast.getFullYear(), splitmonthlast, splitdaylast].join("/");
          
                    
          
          
          if(this.$route.params.secondScreen.media == '新聞'){

            this.contract_kbn = 1;

          }else if(this.$route.params.secondScreen.media == '雑誌'){

            this.contract_kbn = 5;

          }else{

            this.contract_kbn = 2;

          }
                   

          if(this.theme_name){
    
            this.theme_name_id=this.theme_name;

          }else{
       
            this.theme_name_id='';
          }

          if(this.theme_name == '0' || this.theme_name == 0){
          
            this.theme_name_id='';

          }
          var search_title = '';
          if(this.value1 == "検索条件から選択")
          {
            search_title = "";
          }
          else{
            search_title = this.value1;
          }
          var AID0071_InputParameters = "";
          if(this.input1 == ''){
            AID0071_InputParameters={

              contract_id : this.contractId,
              user_id : this.userId,
              theme_id : this.theme_name_id,
              topics_id : this.topics_id,
              media_name : this.input2,
              search_title : search_title,
              process_date_from : startResult,
              process_date_to : startResultlast,
              display_id : 'SID1019',
              contract_kbn : this.contract_kbn,
              theme_browsing : this.theme_browsing

            };
          }
          else
          {

            AID0071_InputParameters={

              contract_id : this.contractId,
              user_id : this.userId,
              theme_id : this.theme_name_id,
              topics_id : this.topics_id,
              key_word : this.input1,
              media_name : this.input2,
              search_title : search_title,
              process_date_from : startResult,
              process_date_to : startResultlast,
              display_id : 'SID1019',
              contract_kbn : this.contract_kbn,
              theme_browsing : this.theme_browsing

            };
          }
          /******1572 related fix********/
          this.AID0071_InputParams = AID0071_InputParameters;
          //Change by CK for backlog ID :1734 display article details in first tab aid0071 call
          //Vue.prototype.$session.set('InputParameterFor0006',AID0071_InputParameters);
          //Vue.prototype.$session.set('CurrentAID',"0071");
          // 2022/09/12  #13561  START
          this.Buttonpressed= 1;
          // 2022/09/12  #13561  END
          this.$store.dispatch("communication1019002/AID0071_Search",AID0071_InputParameters).then(() =>{
              this.articlecount = this.getArticleCount;
              var second_tabrecords = this.getRegisteredRecords;
              if(second_tabrecords.length > 0){
                
                this.$nextTick(function(){

                  this.toggleSelection(this.getRegisteredRecords);

                });
              }
              // 2021/11/13  #12035  START
              //this.Aid0046_Get_WhenSearch();
              // 2021/11/13  #12035  END
              this.loading = false;
              // 2022/09/12  #13561  START
              this.Buttonpressed= 0;
              // 2022/09/12  #13561  END
              // 2024/05/14  #13819  START
              var status = this.getStatus;
              var msgdetail = this.getErrorMessage;
              if(status == "1")
              {
                this.$alert(msgdetail,"確認", {  confirmButtonText: 'OK',dangerouslyUseHTMLString:true })
              }
              // 2024/05/14  #13819  END
          });
        }

          
        this.$LogMethodOut("1019-002","AID0071_Search");
        
      },
      handleSelectionChange(val) {

        this.$LogButtonEvent("1019-002","SelectionChange");
        this.$LogMethodIN("1019-002","handleSelectionChange");
        var SecondTabData = [];
        newArr.value=  val;
        this.NewsArticle = [];

        // 2022/03/28 #12564 START
        // /*** Change by AJ for backlog Id: 1509 */
        // for( var k=this.staticArrayForSecondTab.length - 1; k>=0; k--){
        //   for( var j=0; j<val.length; j++){
        //     if(this.staticArrayForSecondTab[k] && (this.staticArrayForSecondTab[k].article_id === val[j].article_id)){
        //         this.staticArrayForSecondTab.splice(k, 1);
        //     }
        //   }
        // }
        // /*** Change by AJ for backlog Id: 1509 */
        // 記事選択Tab内選択した記事が並び替えリスト（内部変数）に削除する
        for (var k = this.staticArrayForSecondTabRegistered.length - 1; k >= 0; k--) {
          for (var j = 0; j < val.length; j++) {
            if (this.staticArrayForSecondTabRegistered[k] && (this.staticArrayForSecondTabRegistered[k].article_id === val[j].article_id)) {
              this.staticArrayForSecondTabRegistered.splice(k, 1);
            }
          }
        }
        // 2022/03/28 #12564 END
        
        for(var i=0;i<val.length;i++)
        {
          // 2020/11/17  BT08460_EXTERNAL-1797  START
          if(val[i].article_id==''){
            continue;
          }
          // 2020/11/17  BT08460_EXTERNAL-1797  END
          var secondtabinner = {};
          secondtabinner.no = i;
          secondtabinner.article_id = val[i].article_id;
          secondtabinner.title = val[i].title;
          secondtabinner.media_name = val[i].media_name;
          secondtabinner.issue_date = val[i].issue_date;
          secondtabinner.issue_type = val[i].issue_type;
          secondtabinner.frame_no = val[i].frame_no;
          secondtabinner.char_count = val[i].char_count;
          secondtabinner.search_word = val[i].search_word;
          secondtabinner.theme_name = val[i].theme_name;
          secondtabinner.comment = val[i].comment;
          secondtabinner.article_text = val[i].article_text;
          secondtabinner.data_section = val[i].data_section;
          secondtabinner.pdf_key = val[i].pdf_key;
          secondtabinner.other_article = val[i].other_article;
          secondtabinner.display_order = val[i].display_order;
          secondtabinner.image_info = val[i].image_info;
          secondtabinner.no_text_flag = val[i].no_text_flag;
          secondtabinner.no_image_flag = val[i].no_image_flag;
          /*** Change by CK for backlog Id: 1579 */
          secondtabinner.media_type = val[i].media_type;

          secondtabinner.cover_date = val[i].cover_date;
          secondtabinner.sales_datetime = val[i].sales_datetime;
          secondtabinner.page = val[i].page;
          secondtabinner.category = val[i].category;
          secondtabinner.sales_datetime_flag = val[i].sales_datetime_flag;
          secondtabinner.start_page = val[i].start_page;
          secondtabinner.contents_id = val[i].contents_id;
          
          // 2023/09/19 #15967 START
          secondtabinner.url = val[i].url;
          secondtabinner.sales_to_datetime = val[i].sales_to_datetime;
          // 2023/09/19 #15967 END
          
          SecondTabData.push(secondtabinner);
             
        }

        // 2022/03/28 #12564 START
        // /*** Change by AJ for backlog Id: 1509 */
        // // 2022/02/17  #12398  START
        // //var secondTabArticleDetail = SecondTabData.concat(this.staticArrayForSecondTab)
        // var secondTabArticleDetail = this.staticArrayForSecondTab.concat(SecondTabData)
        // // 2022/02/17  #12398  END
        // /*** Change by AJ for backlog Id: 1509 */
        // 2022/03/28 #12564 END

        // 2022/03/28 #12564 START
        // 選択解除処理
        for (var m = this.staticArrayForSecondTab.length - 1; m >= 0; m--) {
          let ret = this.staticArrayForSecondTabRegistered.find(item => item.article_id == this.staticArrayForSecondTab[m].article_id);
          if (!ret) {
            let retAdd = SecondTabData.find(item => item.article_id == this.staticArrayForSecondTab[m].article_id);
            if (!retAdd) {
              // 並び替えリスト（内部変数）と記事選択Tab内選択された記事の両方が存在しない場合は並び替えリスト（表示用）から削除する
              this.staticArrayForSecondTab.splice(m, 1);
            }
          }
        }
        // 選択追加処理
        for (var n = 0; n < SecondTabData.length; n++) {
          let ret = this.staticArrayForSecondTab.find(item => item.article_id == SecondTabData[n].article_id);
          if (!ret) {
            // 記事選択Tab内選択された記事は並び替えリスト（表示用）に存在されない記事のみ追加する
            this.staticArrayForSecondTab.push(SecondTabData[n]);
          }
        }
        var secondTabArticleDetail = this.staticArrayForSecondTab;
        // 2022/03/28 #12564 END

        this.second_tab_label = this.second_tab_label = "並び替え("+ secondTabArticleDetail.length + "件)";
        this.$store.commit('situation1019002/SID1019_RegisteredRecords', secondTabArticleDetail);

        this.sample_data = val;
        
        
        this.multipleSelection = val;
        this.$LogMethodOut("1019-002","handleSelectionChange");
      },

      changeConditions(index){
        this.$LogButtonEvent("1019-002","Searchcondition");
        this.$LogMethodIN("1019-002","changeConditions");
        this.input1 = "";
        this.input2 = "";
        
        if(index == "検索条件から選択"){

          this.value1= "";
          this.clickable = false;

        }
        else{

          this.value1 = index;
          this.clickable = true;

        }
        this.$LogMethodOut("1019-002","changeConditions");
      },
      theme_condition(index){
        this.$LogButtonEvent("1019-002","SelectTheme");
        this.$LogMethodIN("1019-002","themecondition");
        var theme_dropdown = this.getDropdownFortheme;
        for (var i =0;i<theme_dropdown.length;i++){
            if(index == theme_dropdown[i].theme_name){
              this.theme_name = theme_dropdown[i].theme_id;
            }
        }
          
        this.$LogMethodOut("1019-002","themecondition");
      },
      //Method for merge the columns of comments for Articles
      arraySpanMethod({ rowIndex, columnIndex }) {
        
        // This will check the IndexArray of Comments to merge the columns of Comments
        if (this.getarticleCommentIndexArray.indexOf(rowIndex) > -1) {
          if (columnIndex === 1) {
            // no
            
            return [1, 2]; // This will take colspan = 2
          // 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START
          } else if (this.media_section == 5 && columnIndex === 2) {
            return [1,8];
          // 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END
          } else if (columnIndex === 2) {
            //HeaderText
            
            return [1,7]; // This will take colspan = 5
          } else {
            return [0, 0];
          }
        }
      },
      calenderChange(){
      
      },
      Aid0046_Get_WhenSearch(){
         var AID0046_InputParameters = {
              topics_id : this.topics_id,
              data_section : this.media_section,
              process_date : this.$route.params.secondScreen.date
          };
          this.$store.dispatch('communication1019002/AID0046_Get',AID0046_InputParameters);
      },
      Aid0046_Get(aid){
          var AID0046_InputParameters = {
              topics_id : this.topics_id,
              data_section : this.media_section,
              process_date : this.$route.params.secondScreen.date
          };
          /**********1572 related fix**********/
          this.AID0046_InputParams = AID0046_InputParameters;
         // Vue.prototype.$session.set('InputParameterFor0006',AID0046_InputParameters);
         // Vue.prototype.$session.set('CurrentAID',"0046");
          this.$store.dispatch('communication1019002/AID0046_Get',AID0046_InputParameters).then(() =>{
            /*** Change by AJ for backlog Id: 1509 */
            this.staticArrayForSecondTab = this.getRegisteredRecords;
            /*** Change by AJ for backlog Id: 1509 */
            // 2021/11/18  #12035  START
            this.staticArrayForDelete = JSON.stringify(this.getRegisteredRecordsForDelete);
            // 2021/11/18  #12035  END
           
            if(this.getRegisteredDataCount != '0' || this.getRegisteredDataCount != 0){
              this.activeName = 'second';
            }
            
            this.second_tab_label = "並び替え("+ this.getRegisteredDataCount + "件)";

            // display in order by display_order property
            //Removed sort code since sort handled in communication

           this.AID0071_Search();
            if(aid == 'AID0046_Delete'){
              router.push({
                name: "1019-001"
              })
            }

          });     
      },
      // 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 START
      tableCellClassName({column}) {
        if (typeof(column.property) == "undefined") {
          return 'text-center'
        } else if (column.property == "display_order") {
          return 'text-center'
        } else {
          return "text-start"
        }
      },
      // 2022/09/13  No4.雑誌/WEBニュースへの検索語追加 END
    },
    computed: {
      ...mapGetters("situation1019002", [
        "getresultJson0071",
        "getArticleCount",
        "getTableResult1019002",
        "getcheck",
        "getTitle",
        "getTopic",
        "getMedia",
        "getNews",
        "getClipText",
        "getClipDate",
        "getSelectOption",
        "getMsgDetail",
        "getcheckboxSelectedArray",
        "getSecondTabData",
        "getcategoryArray",
        "getdropdownDataArray",
        "getDropdownForSearchSituation",
        "getarticleSecondCommentIndexArray",
        "getDropdownFortheme",
        "getarticleCommentIndexArray",
        "getRegisteredRecords",
        "getResponse",
        "getRegisteredDataCount",
        "getRegisteredRecordsForDelete",
        "getSID1019_RegisteredRecords_count",
        "getEpubDownloadErrStatus",
        "getEpubDownloadErrmsgDetail",
        "getcountMax"
      ]),
      // 2024/05/14  #13819  START
      ...mapGetters("situation0003",["getStatus","getErrorMessage","getMessageCode"]),
      // 2024/05/14  #13819  END
      ...mapGetters("situation0001", [
        "getUserId",
        "getContractId",
        "getThemeBrowsing",
        "getContractCode",
        "getUserGroupName",
        "getMessageInfo",
        "getMC_Pdf_View_Flag",
        "getMC_Pdf_Print_Flag",
        "getMC_Text_View_Flag",
        "getMC_Text_Print_Flag",
        "getSC_Pdf_View_Flag",
        "getSC_Pdf_Print_Flag",
        "getSC_Text_View_Flag",
        "getSC_Text_Print_Flag",
        "getCompanyConfigurationInfo",
        "getOut_Demand_Confirm_Message_Div_Flag",
        "getDemandConfirmPdfMessage",
        "getDemandConfirmTextMessage",
        "getDemandConfirmPrintMessage"

      ])
    },
    beforeCreate(){
      //For the screen Title
      document.title = "トピックス作成画面";
      //get the service linkage info value from the session
    
      //Common.Session.CheckSessionExists_IfExpired_GoToLogout();
      
      // Set the default value 0
      // when the page is about to load
      this.articlecount = 0;
      
      
    },
    watch: {
    'articlecount': function (val) {
      this.articlecount = val;
    },
    
    'date.start': function(newVal){
        var splitData = new Date(newVal),
          splitmonth = ("0" + (splitData.getMonth() + 1)).slice(-2),
          splitday = ("0" + splitData.getDate()).slice(-2);
        var startResult = [splitData.getFullYear()+'年', splitmonth+'月', splitday+'日'].join("");
        
        this.startDate=startResult;
    },
    'date.end': function(newVal){
        var splitData = new Date(newVal),
          splitmonth = ("0" + (splitData.getMonth() + 1)).slice(-2),
          splitday = ("0" + splitData.getDate()).slice(-2);
        var endResult = [splitData.getFullYear()+'年', splitmonth+'月', splitday+'日'].join("");
        
        this.endDate=endResult;
    }
  },
  mounted(){

    // Values will be set in state variables.
    this.OnLoad();     
    


     
    
     

  }
};
</script>
<style scoped>
@import "1019-002.css";
/* Disable icon style */
.ico_pdf_Disable {
  background: url("../../assets/image/ico_pdf_up.svg") no-repeat;
  width: 22px;
  height: 22px;
  opacity: 0.2;
}

.ico_article_details_Disable {
  background: url("../../assets/image/ico_article-details_up.svg") no-repeat;
  width: 22px;
  height: 22px;
  opacity: 0.2;
}

.ico_text_Disable {
  background: url("../../assets/image/ico_text_up.svg") no-repeat;
  width: 22px;
  height: 22px;
  opacity: 0.2;
}

.ico_print_Disable {
  background: url("../../assets/image/ico_print_up.svg") no-repeat;
  width: 22px;
  height: 22px;
  opacity: 0.2;
}

.article-top-disable {
  font-size: 10.4pt;
  font-weight: bold;
  font-family: BIZ UDゴシック;
  padding-right: 0px;
  color: #000;
  cursor: default;
  display: block;
  margin-top: 9px;
  line-height: 22px;
  margin-left: 8px;  
}

.article-top-disable:focus {
  outline: none;
}
</style>